
















import Vue from 'vue';

export default Vue.extend({
  name: 'PPill',
  props: {
    label: { type: String, default: undefined },
    clearable: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    color: { type: String, default: 'interaction' },
  },
});
